function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "icon-rounded-calendar-hollow");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.2
}, /*#__PURE__*/React.createElement("path", {
  d: "M23,.5A4.50508,4.50508,0,0,1,27.5,5V23A4.50508,4.50508,0,0,1,23,27.5H5A4.50508,4.50508,0,0,1,.5,23V5A4.50508,4.50508,0,0,1,5,.5H23M23,0H5A5,5,0,0,0,0,5V23a5,5,0,0,0,5,5H23a5,5,0,0,0,5-5V5a5,5,0,0,0-5-5Z",
  fill: "#333"
}));

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 7,
  y: 7,
  width: 14,
  height: 14,
  rx: 1.5,
  fill: "none",
  stroke: "#333",
  strokeMiterlimit: 10,
  strokeWidth: 1.25
});

var _ref5 = /*#__PURE__*/React.createElement("line", {
  x1: 10.25,
  y1: 9,
  x2: 10.25,
  y2: 5,
  fill: "none",
  stroke: "#333",
  strokeMiterlimit: 10,
  strokeWidth: 1.25
});

var _ref6 = /*#__PURE__*/React.createElement("line", {
  x1: 17.75,
  y1: 9,
  x2: 17.75,
  y2: 5,
  fill: "none",
  stroke: "#333",
  strokeMiterlimit: 10,
  strokeWidth: 1.25
});

var _ref7 = /*#__PURE__*/React.createElement("line", {
  x1: 7,
  y1: 11,
  x2: 21,
  y2: 11,
  fill: "none",
  stroke: "#333",
  strokeMiterlimit: 10,
  strokeWidth: 1.25
});

var _ref8 = /*#__PURE__*/React.createElement("line", {
  x1: 16.39708,
  y1: 13.73607,
  x2: 16.39708,
  y2: 15.94722,
  fill: "none",
  stroke: "#333",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 0.75
});

var _ref9 = /*#__PURE__*/React.createElement("line", {
  x1: 14.29415,
  y1: 15.26393,
  x2: 16.39708,
  y2: 15.94722,
  fill: "none",
  stroke: "#333",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 0.75
});

var _ref10 = /*#__PURE__*/React.createElement("line", {
  x1: 15.0974,
  y1: 17.73607,
  x2: 16.39708,
  y2: 15.94722,
  fill: "none",
  stroke: "#333",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 0.75
});

var _ref11 = /*#__PURE__*/React.createElement("line", {
  x1: 17.69675,
  y1: 17.73607,
  x2: 16.39708,
  y2: 15.94722,
  fill: "none",
  stroke: "#333",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 0.75
});

var _ref12 = /*#__PURE__*/React.createElement("line", {
  x1: 18.5,
  y1: 15.26393,
  x2: 16.39708,
  y2: 15.94722,
  fill: "none",
  stroke: "#333",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 0.75
});

const SvgRoundedCalendar = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e4de4300-4bdd-4d8a-a245-4a55340a3635",
    "data-name": "Layer 1",
    viewBox: "0 0 28 28",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRoundedCalendar, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/rounded-calendar.50cd6947.svg";
export { ForwardRef as ReactComponent };